const TimeInterval = Object.freeze({
  LAST_HOUR: 'LAST_HOUR',
  LAST_DAY: 'LAST_DAY',
  LAST_WEEK: 'LAST_WEEK',
  LAST_MONTH: 'LAST_MONTH',
  LAST_QUARTER: 'LAST_QUARTER',
  LAST_SIX_MONTHS: 'LAST_SIX_MONTHS',
  LAST_YEAR: 'LAST_YEAR',
  LAST_15MONTHS: 'LAST_15MONTHS',
  LAST_18MONTHS: 'LAST_18MONTHS',
  LAST_21MONTHS: 'LAST_21MONTHS',
  LAST_2YEARS: 'LAST_2YEARS',
  LAST_27MONTHS: 'LAST_27MONTHS',
  LAST_51MONTHS: 'LAST_51MONTHS',
  OPEN_END: 'OPEN_END',
  CUSTOM: 'CUSTOM',
  ALL: 'ALL'
})
export default TimeInterval
export type TimeIntervalStrings = typeof TimeInterval[keyof typeof TimeInterval]
// RESERVE BELOW
